<ol *ngIf="breadcrumbs.length > 0" class="breadcrumb">
  <li *ngFor="let breadcrumb of breadcrumbs"><a [routerLink]="[breadcrumb.url]" [ngClass]="{'disabled-link': !breadcrumb.url}">{{ breadcrumb.label }}</a></li>
</ol>